import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BasketFreeDeliveryNoticeComponentDef } from '@df/basket/free-shipping/basket-free-delivery-notice.component.def';
import { ClickEventDirective } from '@df/ui/common/click-event.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import compact from 'lodash-es/compact';
import values from 'lodash-es/values';
import { IBasketDataFreeShippingMinAmount } from '../../customer/api/basket/basket.decorator';
import { MinibasketComponent } from '../minibasket/minibasket.component';

@Component({
    selector: 'basket-free-delivery-notice',
    templateUrl: './basket-free-delivery-notice.html',
    standalone: true,
    imports: [CommonModule, ClickEventDirective, RouterModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketFreeDeliveryNoticeComponent extends BasketFreeDeliveryNoticeComponentDef implements OnInit {
    /**
     * Component background color
     */
    @Input()
    backgroundColor?: string;

    @Input()
    textColor?: string;

    @Input()
    isBasketView = false;

    private freeshippingminamounts = values(this.basket.data.freeshippingminamounts);

    protected renderer = inject(Renderer2);
    protected minibasketComponent = inject(MinibasketComponent, { optional: true });

    get containsFurnitureRules(): boolean {
        return !!this.basket.data.contains_furniture;
    }

    get notFurnitureOnly(): boolean {
        return !!this.basket.data.not_furniture_only;
    }

    get userHaveMaxDiscount(): boolean {
        /**
         * maximum value needed for discount
         */
        const maxDiscountValue = Math.max(...compact(this.freeshippingminamounts?.map(amount => amount.value)));

        return this.basket.totals.subtotal >= maxDiscountValue ? true : false;
    }

    get currentActiveRule(): IBasketDataFreeShippingMinAmount | undefined {
        const sortedRules = this.freeshippingminamounts.sort((a, b) => a.value - b.value);

        return sortedRules.find(rule => rule.value > this.basket.totals.subtotal);
    }

    close(): void {
        this.minibasketComponent?.hide();
    }

    /**
     * Only make element visible when any rules apply
     */
    override detectChanges(): void {
        super.detectChanges();

        if (this.rules && this.rules.length > 0) {
            this.renderer.removeClass(this.elementRef.nativeElement, 'ng-hide');
        } else {
            this.renderer.addClass(this.elementRef.nativeElement, 'ng-hide');
        }
    }
}
